export function clonseJSON<T>(data: T): T {
  return JSON.parse(JSON.stringify(data));
}
